import { Box } from '@factorialco/deprecated-design-system'
import { Alert, AlertTitle } from '@factorialco/f0-react/dist/experimental'
import { AlertFinancialDocumentEventFragment } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { draftWithErrorsOnClient } from 'modules/finance/components/Invoices/SaleInvoiceActivity/utils'

interface AlertIssuedWithErrorsProps {
  financialDocumentEvents: AlertFinancialDocumentEventFragment[]
  validated: boolean
}

const AlertErrorsOnClient = ({
  financialDocumentEvents,
  validated,
}: AlertIssuedWithErrorsProps) => {
  const withDraftErrors = useUnsafeMemo(() => {
    return draftWithErrorsOnClient(validated, financialDocumentEvents)
  }, [financialDocumentEvents, validated])

  if (!withDraftErrors) {
    return null
  }

  return (
    <Box width="full" paddingX="s20" paddingBottom="s16">
      <Alert variant="warning">
        <AlertTitle>{i18n.t('finance.sale_invoices.detail.alert_draft_with_errors')}</AlertTitle>
      </Alert>
    </Box>
  )
}

export default AlertErrorsOnClient
